<template>
  <div class="new-device">
    <b-overlay :show="loading" opacity="0.99">
      <div class="mt-10 container">
        <div class="row justify-content-md-center">
          <v-card class="col-xl-5 col-lg-6 col-md-8 col-sm-12 col-12">
            <v-card-title class="title-pages">
              Registro do Dispositivo
            </v-card-title>
            <v-card-text>
              <WarningMessage
                message="Este dispositivo não está registrado no sistema. Caso não tenha um código, entre em contato com o administrador."
              />
              <div class="form-group">
                <LabelRequiredField label="Informe o Código" />
                <input
                  type="text"
                  class="form-control col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-model="code"
                />
                <ErrorsMessages :errors="errors" />
                <WarningRequiredFields />
              </div>
            </v-card-text>
            <v-card-actions>
              <div class="row"></div>
              <div class="col-auto align-self-end">
                <v-btn class="btn-acess" @click="requestToken">
                  <i class="fas fa-pencil-alt icon-register mr-2 text-twenty">
                  </i>
                  REGISTRAR
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<style>
.new-device .icon-register {
  margin-right: 3px;
}
</style>

<script>
import api from "../services/api";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import routes from "../routes";

export default {
  name: "Devices",
  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
  },
  data() {
    return {
      errors: [],
      loading: false,
      code: "",
    };
  },
  created() {
    routes.push({ name: "sign-in" });
    // this.isNewDevice();
  },
  methods: {
    async isNewDevice() {
      try {
        this.loading = true;
        const response = await api.get("/status/allowed-device");
        const { error, errors, allowed_device } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          if (allowed_device) routes.push({ name: "sign-in" });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async requestToken() {
      try {
        this.loading = true;

        let { code } = this;
        let response = await api.post("/rest-home/devices/request/token", {
          code,
        });
        let { error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          routes.push({ name: "sign-in" });
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
